import { mixed, object, string } from 'yup';

export const qualificationValidations = {
  qualification: object().shape({
    id: string().notRequired(),
    placeofLearning: string().required('Place of Learning required'),
    typeofCertification: object()
      .shape({
        label: string().required('Select type of certification'),
        value: string(),
      })
      .required('Type of certification required'),
    levelofCertification: object()
      .shape({
        label: string(),
        value: string(),
      })
      .nullable()
      .notRequired(),
    certificate: mixed<File>().required('Certificate file required').nullable(),
    certificateError: object()
      .shape({
        errorMessage: string().notRequired(),
      })
      .notRequired()
      .nullable(),
    certificateId: string().required('Upload file before proceeding'),
    documentFileName: string().notRequired(),
    documentFileSize: string().notRequired(),
  }),
};
